import backendConnector from './backendConnector';
import Logger from '../services/logger';

export const STATIC_LOOKUPS = 'STATIC_LOOKUPS';

const dataCache = {
    [STATIC_LOOKUPS]: null,
};

export default class StaticDataHttpService {
    static getStaticData() {
        if (dataCache[STATIC_LOOKUPS]) {
            return Promise.resolve(dataCache[STATIC_LOOKUPS]);
        }

        return backendConnector.get('metadata/staticLookups/en-US')
            .then((staticData) => {
                dataCache[STATIC_LOOKUPS] = staticData;

                return staticData;
            }).catch((error) => Logger.error(error));
    }
}
